// @ts-nocheck
import xlsx from 'xlsx'
import {xzqUtils} from '@/views/class/mapmanager'
import { Notification } from 'element-ui'
const importLand = {
  queryImport: null,
  importLandList(obj, queryImport) {
    const _this = this
    _this.queryImport = queryImport
    let dkList = {}
    // var a =importLand.importLandList(obj);
    // 通过DOM取文件数据
    this.file = obj
    const rABS = false
    const f = this.file
    const reader = new FileReader()
    FileReader.prototype.readAsBinaryString = function (f) {
      let binary = ''
      const rABS = false
      const pt = this
      let wb // 读取完成的数据
      let outdata
      const reader = new FileReader()
      dkList = reader.onload = function (e) {
        const bytes = new Uint8Array(reader.result)
        const length = bytes.byteLength
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        const XLSX = require('xlsx')
        if (rABS) {
          wb = XLSX.read(btoa(fixdata(binary)), { // 手动转化
            type: 'base64'
          })
        } else {
          wb = XLSX.read(binary, {
            type: 'binary'
          })
        }
        outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])// 读取excel内容之后输出的信息
        this.da = [...outdata]
        // 把读取的excel表格中的内容放进fileData中
        this.fileData = this.da
        if (this.fileData.length > 0) {
          dkList = _this.importData(this.fileData)
          if (_this.queryImport) {
            _this.queryImport(dkList)
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '未查到相关数据,请重新选择文件！',
            type: 'warning'
          })
        }
      }
      reader.readAsArrayBuffer(f)
    }
    if (rABS) {
      reader.readAsArrayBuffer(f)
    } else {
      reader.readAsBinaryString(f)
    }
  },
  importData(data) {
    // eslint-disable-next-line no-array-constructor
    let dkLists = new Array()
    if (data && data.length > 0) {
      // eslint-disable-next-line no-array-constructor
      const tLandinfos = new Array()
      for (let i = 0; i < data.length; i++) {
        const dkData = data[i]
        const dkList = {}
        if (dkData.申请单位) {
          dkList.sqdw = dkData.申请单位
        }
        if (dkData.地块名称) {
          dkList.dkmc = dkData.地块名称
        }
        if (dkData.地块位置) {
          dkList.dkdz = dkData.地块位置
        }
        const dkmj = '地块面积(亩)'
        if (dkData[dkmj]) {
          dkList.dkmj = dkData[dkmj]
          dkList.dkmj = parseFloat(dkList.dkmj)
        }
        if (dkData.行政区) {
          dkList.xzq = dkData.行政区
          dkList.xzq = xzqUtils.getXZQCODE(dkList.xzq)
        }
        // if(dkData.用地性质){
        //   dkList.ydxz =dkData.用地性质
        // }
        if (dkData.土地用途) {
          dkList.tdyt = dkData.土地用途
          const str = dkList.tdyt
          const ydxz = str.substring(0, 4)
          if (ydxz === '住宅用地') {
            dkList.ydxz = '1'
          } else if (ydxz === '商服用地' || ydxz === '商业用地') {
            dkList.ydxz = '2'
          } else if (ydxz === '工业用地') {
            dkList.ydxz = '3'
          } else {
            dkList.ydxz = '4'
          }
        }
        const pgzj = '评估亩均价(万元)'
        if (dkData[pgzj]) {
          dkList.pgzj = dkData[pgzj]
        }
        const pgmjj = '评估总价(万元)'
        if (dkData[pgmjj]) {
          dkList.pgmjj = dkData[pgmjj]
        }
        const pglmdj = '楼面地价(元/㎡)'
        if (dkData[pglmdj]) {
          dkList.pglmdj = dkData[pglmdj]
        }
        if (dkData.供地方式) {
          dkList.gdfs = dkData.供地方式
        }
        if (dkData.供地时间) {
          dkList.gdsj = dkData.供地时间
          dkList.gdsj = parseFloat(dkList.gdsj)
          dkList.gdsj = (dkList.gdsj - 25569) * 86400000
        }
        if (dkData.开发程度) {
          dkList.kfcd = dkData.开发程度
        }
        if (dkData.会审状态) {
          dkList.ghzt = dkData.会审状态
          if (dkList.ghzt === '已过会') {
            dkList.ghzt = '1'
          } else {
            dkList.ghzt = '0'
          }
        }
        if (dkData.会审时间) {
          dkList.ghsj = dkData.会审时间
          dkList.ghsj = parseFloat(dkList.ghsj)
          dkList.ghsj = (dkList.ghsj - 25569) * 86400000
        }
        if (dkData.招商联系人) {
          dkList.lxr = dkData.招商联系人
        }
        if (dkData.招商联系电话) {
          dkList.lxdh = dkData.招商联系电话
        }
        if (dkData.推介说明) {
          dkList.tjsm = dkData.推介说明
        }
        if (dkData.容积率) {
          dkList.rjl = dkData.容积率
        }
        if (dkData.绿化率) {
          dkList.lhl = dkData.绿化率
        }
        if (dkData.出让年限) {
          dkList.crnx = dkData.出让年限
        }
        if (dkData.建筑限高) {
          dkList.jzxg = dkData.建筑限高
        }
        if (dkData.建筑密度) {
          dkList.jzmd = dkData.建筑密度
        }
        if (dkData.其他规划条件) {
          dkList.qt = dkData.其他规划条件
        }
        if (dkData.社区配套) {
          dkList.sqpt = dkData.社区配套
        }
        if (dkData.养老配套) {
          dkList.ylpt = dkData.养老配套
        }
        if (dkData.教育配套) {
          dkList.jypt = dkData.教育配套
        }
        if (dkData.其他规划配套) {
          dkList.qtpt = dkData.其他规划配套
        }
        if (dkData.地块编号) {
          dkList.dkbh = dkData.地块编号
        }
        if (dkData.成交价) {
          dkList.cjj = dkData.成交价
          dkList.cjj = parseFloat(dkList.cjj)
        }
        if (dkData.出让状态) {
          dkList.crzt = dkData.出让状态
          if (dkList.crzt === '已出让') {
            dkList.crzt = '1'
          } else {
            dkList.crzt = '0'
          }
        }
        if (dkData.竞得人) {
          dkList.jdr = dkData.竞得人
        }
        if (dkData.成交日期) {
          dkList.jdrq = dkData.成交日期
          dkList.jdrq = parseFloat(dkList.jdrq)
          dkList.jdrq = (dkList.jdrq - 25569) * 86400000
        }
        if (dkList.dkmc && dkList.dkmc !== undefined) {
          tLandinfos.push(dkList)
        }
      }
      if (tLandinfos && tLandinfos.length > 0) {
        dkLists = tLandinfos
        return dkLists
      } else {
        return dkLists
      }
    } else {
      return dkLists
    }
  }

}

export {
  importLand
}
